import { EnvironmentConfig } from './environment-config.model';

const apiBasePath = 'https://pro.stillmandigital.com/client-api';
const wsBasePath = 'wss://pro.stillmandigital.com/client-api';

export const environment: EnvironmentConfig = {
  production: true,
  isBermuda: false,
  apiBasePath,
  wsBasePath,
  recaptchaSitekey: '6LcsrF8tAAAAAAbqXuEc3zpUy2ZrGJiK0vQxwPS6',
  googleSsoEnabled: true,
  googleClientId:
    '302174659507-k1mqvbbc9u551hbn8otpifnuq9abcvtp.apps.googleusercontent.com',
  coinlionEnabled: false,
  coinlionEmbedUrl: 'https://partner.coinlion.com/embed',
};
